<template>
  <b-col cols="12" class="case-text">
    <b-row>
      <b-col>
        <b-row>
          <b-col class="reportLabel col-2">
            Overall Rating
          </b-col>
        </b-row>
        <b-row>
          <b-col v-bind:class="oigCase.assessment.overallRating.toLowerCase()" class="text-center col-2 py-2 px-0 mx-2">
            {{ oigCase.assessment.overallRating }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label class="reportLabel mt-2">OIG Case Number</label>
        <span class="font-weight-bold">{{ oigCase.number }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label class="reportLabel mt-2">Case Summary</label>
        <span v-html="oigCase.summary" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label class="reportLabel">Case Disposition</label>
        <span v-html="oigCase.disposition" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label class="reportLabel">Overall Inquiry Assessment</label>
        <span v-html="oigCase.assessment.assessment" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <hr />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label class="reportLabel">Questions</label>
      </b-col>
    </b-row>
  </b-col>
</template>
<script>
export default {
  props: {
    oigCase: {
      type: Object
    }
  }
}
</script>
<style></style>